export enum UserScope {
  Self = 'self',
  Team = 'team',
  WholeTeam = 'whole-team',
  All = 'all',
}
